import { CookieConsents } from './types';
const encodeCookieConsentsData = (consents) => {
    var _a;
    return JSON.stringify(CookieConsents.encode(Object.assign(Object.assign({}, consents), { createdAt: (_a = consents.createdAt) !== null && _a !== void 0 ? _a : new Date() })));
};
export { encodeCookieConsentsData };
